import * as React from "react";
import { Loader } from "../../ui";

const FullWidthLoader = () => <Loader fullWidth paddings />;

export default FullWidthLoader;
